import { inject, Injectable } from '@angular/core';
import { ClockType } from '../../_shared/models/enums/clock-type.enum';
import { Clock } from '../../_shared/models/clock.model';
import { ClockName } from '../../_shared/models/enums/clock-name.enum';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CreateMatchService {
  private datePipe = inject(DatePipe)

  constructor() { }

  getClockConfig(clockName: ClockName, clockType: ClockType, defaultValue: number, timePipe: string, ): Clock {
    return {
      _id: undefined,
      name: clockName,
      type: clockType,
      defaultValue: defaultValue,
      displayValue: this.datePipe.transform(defaultValue, timePipe),
      value: defaultValue,
      isPaused: true,
      timePipe: timePipe,
      adjustTime: clockType === ClockType.STOPWATCH ? 1000 : -1000
    }
  }
}
